import Error from '@clearkit/icons/glyphs/Error';

export default function AudienceFormWarning({ message, children }) {
  return (
    <div
      className="border-t bg-yellow-0 border-yellow"
      style={{
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        padding: 24,
      }}>
      <div className="flex mb-3">
        <div className="flex items-center w-10">
          <div>
            <div className="p-1 rounded-full text-yellow bg-yellow bg-opacity-20">
              <Error />
            </div>
          </div>
        </div>
        <div className="flex-1">
          <div className="text-yellow-700">{message}</div>
        </div>
      </div>

      {children}
    </div>
  );
}
